import type { ListSegment, SeedListData } from '@openx/types/segments.ts';

export const mapListSegmentToSeedListData = (data?: ListSegment[], isOnList = false): SeedListData[] => {
  if (!data?.length) {
    return [];
  }

  return data.map(item => ({
    id: item.id,
    name: item.name,
    isOnList,
    status: item.status ?? '',
    reach: item.reach ?? 0,
    provider: item.provider?.name ?? '',
    account: item.account?.name ?? '',
    updated: item.updated_date ?? '',
    created: item.created_date ?? '',
    expiration_date: item.expiration_date ?? '',
  }));
};
